<template>
    <div>
        <template v-if="haveManufactureUpdate">
            <div class="service-options__notice">
                <h3 class="service-options__notice-heading">Your vehicle recall</h3>
                <p class="service-options__notice-content" v-if="manufacturerUpdate.records.length > 1">Your vehicle has some outstanding manufacturer recalls. We’ve pre-selected the recall for you, and it will be carried out at no additional cost.</p>
                <p class="service-options__notice-content" v-else>Your vehicle has an outstanding manufacturer recall. We’ve pre-selected the recall for you, and it will be carried out at no additional cost.</p>
                <div class="service-options__manufacturer-updates" v-if="manufacturerUpdate.records && manufacturerUpdate.records.length">
                    <ManufacturerUpdateRecord
                        v-for="record in manufacturerUpdate.records"
                        :key="record.code"
                        :record="record"
                        :selected="manufacturerUpdatesSelected"
                        @select="selectUpdate"
                        @attempt-deselect="attemptDeselectUpdate"
                    />
                </div>
            </div>
        </template>
        <template v-else-if="waitingForManufacturerUpdate">
            <div class="service-options__notice">
                <h3 class="service-options__notice-heading service-options__ellipsis">Checking for manufacturer recalls</h3>
            </div>
        </template>

        <Modal
            :open="manufacturerUpdateConfirm.open"
            :vertical-content="true"
            :is-card="true"
            :show-close-icon="true"
            :is-dismissed-on-click-backdrop="true"
            @close="cancelDeselectManufacturerUpdate"
        >
            <template #header>
                <div class="modal__header-container">
                    <h2 class="modal__header-title">Remove Manufacturer Recall?</h2>
                </div>
            </template>
            <template #body>
                <p class="modal__body-text">
                    This recall is recommended by the manufacturer and is applied at no additional cost. It can include important safety, reliability or performance improvements. We strongly advise leaving it selected so our trained technicians can complete it during your visit.
                </p>
                <p class="modal__body-text" v-if="manufacturerUpdateConfirm.record">
                    Are you sure you want to decline this free manufacturer update ({{ manufacturerUpdateConfirm.record.label }} – {{ manufacturerUpdateConfirm.record.code }})?
                </p>
            </template>
            <template #buttons>
                <button type="button" class="btn btn--primary" @click="cancelDeselectManufacturerUpdate">Keep Update</button>
                <button type="button" class="btn btn--secondary" @click="confirmDeselectManufacturerUpdate">Decline Update</button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '../../../core/components/Modal.vue';
import ManufacturerUpdateRecord from './ManufacturerUpdateRecord.vue';

export default {
    name: 'ManufacturerUpdates',
    components: { Modal, ManufacturerUpdateRecord },
    data() {
        return {
            manufacturerUpdateConfirm: {
                open: false,
                record: null,
            },
        };
    },
    computed: {
        ...mapState('OSB', [
            'manufacturerUpdate',
            'manufacturerUpdatesSelected',
            'waitingForManufacturerUpdate',
        ]),
        haveManufactureUpdate() {
            return this.manufacturerUpdate?.['needsCheck'] == true;
        },
    },
    methods: {
        selectUpdate(record) {
            this.$store.commit('OSB/toggleManufacturerUpdate', record);
        },
        attemptDeselectUpdate(record) {
            // Open confirmation modal; record remains selected until confirmed removal
            this.manufacturerUpdateConfirm.record = record;
            this.manufacturerUpdateConfirm.open = true;
        },
        confirmDeselectManufacturerUpdate() {
            if (!this.manufacturerUpdateConfirm.record) return;
            this.$store.commit('OSB/toggleManufacturerUpdate', this.manufacturerUpdateConfirm.record);
            this.manufacturerUpdateConfirm.open = false;
            this.manufacturerUpdateConfirm.record = null;
        },
        cancelDeselectManufacturerUpdate() {
            this.manufacturerUpdateConfirm.open = false;
            this.manufacturerUpdateConfirm.record = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.service-options__manufacturer-updates {
    margin-top: 1rem;
    border: 1px solid #e2e6ea;
    border-radius: 4px;
    background: #f9fafb;
}
</style>
